import axios from '../../../axios/index.js'
import router from '@/router'

export default {
  init() {
    axios.interceptors.response.use(
      function(response) {
        return response
      },
      function(error) {
        // const { config, response: { status } } = error
        const { config, response } = error
        const originalRequest = config

        // if (status === 401) {

        if (
          response &&
          response.status === 401 &&
          !config.url.includes('auth')
        ) {
          if (!isAlreadyFetchingAccessToken) {
            isAlreadyFetchingAccessToken = true
            store
              .dispatch('auth/fetchAccessToken')
              .then(access_token => {
                isAlreadyFetchingAccessToken = false
                onAccessTokenFetched(access_token)
              })
              .catch(error => {
                localStorage.removeItem('accessToken')
                localStorage.removeItem('userInfo')
                router.push('/login').catch(() => {})
              })
          }

          const retryOriginalRequest = new Promise(resolve => {
            addSubscriber(access_token => {
              originalRequest.headers.Authorization = `Bearer ${access_token}`
              resolve(axios(originalRequest))
            })
          })
          return retryOriginalRequest
        } else if (
          config.url.includes('auth') &&
          response.data.hasOwnProperty('error')
        ) {
          return Promise.reject({
            message: response.data.error,
            status: response.data.status,
          })
        }
        return Promise.reject(error)
      },
    )
  },
  verifyAccount(token) {
    return axios.get('auth/verify/'.concat(token))
  },
  getApiKey() {
    return axios.get('/user/apikey')
  },
  generateApiKey() {
    return axios.post('/user/apikey/regenerate')
  },
  changeAccountEmail(email, email_confirm) {
    return axios.patch('user/email', {
      email: email,
      emailconfirm: email_confirm,
    })
  },
  changeAccountPassword(password, password_confirm) {
    return axios.post('user/password', {
      old_password: password,
      new_password: password_confirm,
      new_password_confirm: password_confirm,
    })
  },
  verifySubAccount(network_id, user_id) {
    return axios.get(`networks/${network_id}/subUsers/${user_id}/verify`)
  },
}
